<template>
    <div v-if="openCheckRewardModal" class="check-reward-modal d-flex justify-content-center">
        <div class="inside-modal d-flex flex-column">
            <div class="d-flex flex-row justify-content-center check-reward-header">
                    <span>TICKETS</span>
                    <button class="close-button" @click="closeCheckReward">x</button>
            </div> 
            <div class="winner-rounds">
                <div v-for="(winnerNumber, idx) in winnerNumbers" :key="idx" style="direction:ltr">
                <div class="d-flex flex-row justify-content-start mt-4 mx-4 windows-command-prompt fs-3 text-white">
                    #{{idx}}
                </div>
                <div class="d-flex flex-row justify-content-center" >
                    <div class="winner-numbers">
                        <img width="283px" src="../assets/images/winning-eggs.webp" alt="">
                        <div class="numbers-positioning">
                            <span class="first-winning-number">{{firstChoosenNumber(winnerNumber.winnerNumber)}}</span>
                            <span class="second-winning-number">{{secondChoosenNumber(winnerNumber.winnerNumber)}}</span>
                            <span class="third-winning-number">{{thirdChoosenNumber(winnerNumber.winnerNumber)}}</span>
                            <span class="fourth-winning-number">{{fourthChoosenNumber(winnerNumber.winnerNumber)}}</span>
                            <span class="fifth-winning-number">{{fifthChoosenNumber(winnerNumber.winnerNumber)}}</span>
                            <span class="sixth-winning-number">{{sixthChoosenNumber(winnerNumber.winnerNumber)}}</span>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div class="button-side-for-edit-numbers">
                <div class="d-flex flex-row justify-content-center px-5">
                    <button class="confirm-and-purchase-button windows-command-prompt">
                        Claim Reward
                    </button>
                </div>
                <div class="d-flex flex-row justify-content-center px-5">
                    <button class="return-button windows-command-prompt" @click="goBackHistory()">
                            &lt;- Return
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'check-reward',
    props: {
        openCheckRewardModal:{
            default: false,
            type: Boolean
        },
    },
    data(){
        return{
            winnerNumbers:[{
                winnerNumber: 653212 
                },
                {
                    winnerNumber: 453212 
                },{
                winnerNumber: 653212 
                },
                {
                    winnerNumber: 453212 
                },{
                winnerNumber: 653212 
                },
                {
                    winnerNumber: 453212 
                }
]
        }
    },
    methods:{
        closeCheckReward(){
            this.$emit('checkRewardModal' ,false)
        },
        goBackHistory(){
            this.$emit('checkRewardModal' ,false)
            this.$emit('openHistoryAndMoreModal' , 'history')
        },
        firstChoosenNumber(number){
            return number.toString()[0]
        },
        secondChoosenNumber(number){
            return number.toString()[1]
        },
        thirdChoosenNumber(number){
            return number.toString()[2]
        },
        fourthChoosenNumber(number){
            return number.toString()[3]
        },
        fifthChoosenNumber(number){
            return number.toString()[4]
        },
        sixthChoosenNumber(number){
            return number.toString()[5]
        }
    },
    computed:{
        
    },
}
</script>

<style>
.check-reward-modal{
    position: fixed;
    top: 10%;
    left: 0;
    z-index: 1055;
    display: block;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
}
.winner-rounds{
    height: 250px;
    overflow: auto;
    direction: rtl;
    margin-left: 30px;
    margin-top: 12px;
}
.winner-rounds::-webkit-scrollbar-track
{
	border-radius: 10px;
	background-color: #FDDE6A;
}

.winner-rounds::-webkit-scrollbar
{
	width: 11px;
}

.winner-rounds::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	background-color: #C0A74A;
}
.check-reward-header {
    background: #131b36;
    width: 100%;
    height: 129px;
    border-top-left-radius: 54px;
    border-top-right-radius: 54px;
    position: relative;
}
.check-reward-header  span{
    font-size: 43px;
    color: #ffe371;
    margin-top: 30px;
}
.confirm-and-purchase-button{
    background: none;
    border-radius: 33px;
    border: solid 4.5px #ffe371;
    color: #ffe371;
    font-size: 30px;
    padding: 0 20px;
}
.winner-numbers{
    color: black;
    font-size: 40px;
    position: relative;
}
.first-winning-number{
    position: absolute;
    left: 4%;
    top: 6%
}
.second-winning-number{
    position: absolute;
    left: 21%;
    top: 6%
}
.third-winning-number{
    position: absolute;
    left: 38%;
    top: 6%
}
.fourth-winning-number{
    position: absolute;
    left:55%;
    top: 6%
}
.fifth-winning-number{
    position: absolute;
    left: 72%;
    top: 6%
}
.sixth-winning-number{
    position: absolute;
    left: 90%;
    top: 6%
}
.return-button{
    border: none;
    background: none;
    font-size: 30px;
    color: white;
    margin-top: 35px;
}
.close-button{
    background: none;
    border: none;
    color: #fff;
    position: absolute;
    right: 20px;
    font-size: 41.5px;
    top: 0;
}
.button-side-for-edit-numbers{
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 192px;
    padding-top: 35px;
    background: #131b36;
    border-bottom-left-radius: 54px;
    border-bottom-right-radius: 54px;
}
.inside-modal{
    width: 430px;
    height: 610px;
    margin: 20px;
    background: #0a0e1c;
    border-radius: 54px;
    border: solid 6px #ffe371;
    position: relative;
    box-shadow: 2px 2px 5pt 5pt #ead287;
}
@media (max-width:790px) {
    
}
</style>